var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "field-wrapper field-wrapper--text",
      class: [
        _vm.field.cssClass,
        { "visually-hidden": _vm.field.visibility === "hidden" },
        "field-wrapper--" + _vm.field.size
      ]
    },
    [
      _c(
        "div",
        {
          staticClass: "field-group field-group--block",
          class: [{ "field-group--is-error": _vm.isError }]
        },
        [
          _c(
            "label",
            {
              staticClass: "label",
              class: [
                {
                  "visually-hidden": _vm.field.labelPlacement === "hidden_label"
                }
              ],
              attrs: { for: "input_" + _vm.formId + "_" + _vm.field.id }
            },
            [
              _vm._v("\n      " + _vm._s(_vm.field.label)),
              _vm.field.isRequired ? _c("sup", [_vm._v("*")]) : _vm._e()
            ]
          ),
          _vm._v(" "),
          _vm.field.inputMaskValue
            ? [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.text,
                      expression: "text"
                    },
                    {
                      name: "mask",
                      rawName: "v-mask",
                      value: _vm.field.inputMaskValue.replace(/9/g, "#"),
                      expression: "field.inputMaskValue.replace(/9/g, '#')"
                    }
                  ],
                  attrs: {
                    id: "input_" + _vm.formId + "_" + _vm.field.id,
                    name: "input_" + _vm.field.id,
                    required: _vm.field.isRequired,
                    placeholder:
                      _vm.field.labelPlacement === "hidden_label"
                        ? _vm.field.placeholder
                        : null,
                    type: "text"
                  },
                  domProps: { value: _vm.text },
                  on: {
                    focus: _vm.inputFocus,
                    blur: _vm.inputBlur,
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.text = $event.target.value
                    }
                  }
                })
              ]
            : [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.text,
                      expression: "text"
                    }
                  ],
                  attrs: {
                    id: "input_" + _vm.formId + "_" + _vm.field.id,
                    name: "input_" + _vm.field.id,
                    autocomplete: _vm.isFieldAutocompletePossible(
                      _vm.field.adminLabel
                    ),
                    required: _vm.field.isRequired,
                    placeholder:
                      _vm.field.labelPlacement === "hidden_label"
                        ? _vm.field.placeholder
                        : null,
                    type: "text"
                  },
                  domProps: { value: _vm.text },
                  on: {
                    focus: _vm.inputFocus,
                    blur: _vm.inputBlur,
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.text = $event.target.value
                    }
                  }
                })
              ]
        ],
        2
      ),
      _vm._v(" "),
      _vm._t("description"),
      _vm._v(" "),
      _vm._t("error")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }